var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 16C208.533 16 162.131 30.0758 122.663 56.4473C83.1955 82.8188 52.4341 120.302 34.269 164.156C16.104 208.01 11.3512 256.266 20.6116 302.822C29.8721 349.377 52.7299 392.141 86.2945 425.706C119.859 459.27 162.623 482.128 209.178 491.388C255.734 500.649 303.99 495.896 347.844 477.731C391.698 459.566 429.181 428.805 455.553 389.337C481.924 349.869 496 303.468 496 256C495.928 192.37 470.619 131.367 425.626 86.3739C380.633 41.3808 319.63 16.072 256 16ZM363.312 219.312L267.312 315.312C264.312 318.312 260.243 319.997 256 319.997C251.757 319.997 247.689 318.312 244.688 315.312L148.688 219.312C145.774 216.294 144.161 212.253 144.197 208.058C144.234 203.862 145.916 199.849 148.883 196.883C151.85 193.916 155.863 192.234 160.058 192.197C164.253 192.161 168.294 193.773 171.312 196.688L256 281.376L340.688 196.688C343.706 193.773 347.747 192.161 351.943 192.197C356.138 192.234 360.151 193.916 363.117 196.883C366.084 199.849 367.766 203.862 367.803 208.058C367.839 212.253 366.227 216.294 363.312 219.312Z",
    fill: "#4BBB46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.534e6baa7f15fc76a4e904bbcfa27486.svg";
export { ForwardRef as ReactComponent };